"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Diagnostics = void 0;
class Diagnostics {
    constructor(reports = []) {
        this.reports = reports;
    }
    add(type, node, message, options = {}) {
        this.reports.push({ type, node, message, options });
    }
    error(node, message, options) {
        this.add('error', node, message, options);
    }
    warn(node, message, options) {
        this.add('warning', node, message, options);
    }
    info(node, message, options) {
        this.add('info', node, message, options);
    }
}
exports.Diagnostics = Diagnostics;
//# sourceMappingURL=diagnostics.js.map